import { render, staticRenderFns } from "./Rating4Star.vue?vue&type=template&id=29e1902e"
import script from "./Rating4Star.vue?vue&type=script&lang=js"
export * from "./Rating4Star.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29e1902e')) {
      api.createRecord('29e1902e', component.options)
    } else {
      api.reload('29e1902e', component.options)
    }
    module.hot.accept("./Rating4Star.vue?vue&type=template&id=29e1902e", function () {
      api.rerender('29e1902e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Rating4Star.vue"
export default component.exports